<template>
  <div class="temp_detail">
    <mrc_ess_iconGroup
      :is_disabled="readonly"
      :showEdit="hasBtn('edit-push-message-template')"
      :show_del="hasBtn('delete-push-message-template')"
      :showReturn="false"
      @handleEdit="handleEdit"
      @handleDel="handleDel"
    ></mrc_ess_iconGroup>
    <v-tabs grow v-model="tabs" background-color="#eeeef0" @change="tabchange">
      <v-tab class="text-capitalize">{{
        $t("label_The_general_information")
      }}</v-tab>
      <v-tab class="text-capitalize">{{ $t("label_The_template") }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <commoninfor
          :disabled="readonly"
          @changeReadonly="handleEdit"
        ></commoninfor>
      </v-tab-item>
      <v-tab-item>
        <langTemplate
          :disabled="readonly"
          :commoninforloading="loading"
          @changeReadonly="handleEdit"
        ></langTemplate>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import {
  updateMessageTemplateDetail,
  getMessageTemplateDetail,
  deleteMessageTemplateDetail,
} from "@/service/api/pushMessageTemplate";
import commoninfor from "./modules/commoninfor";
import langTemplate from "./modules/langTemplate";
export default {
  components: { commoninfor, langTemplate },
  props: {},
  data() {
    return {
      uuid: "",
      readonly: false,
      detail_data: {
        uuid: "",
      },
      tabs: 0,
      loading: false,
    };
  },
  created() {},
  mounted() {
    const uuid = this.$route.params.uuid || this.$store.state.uuid;
    this.readonly = this.$store.state.iconstatus;
    this.tab = this.$store.state.tab;
    this.uuid = uuid;
    // 功能详情
    if (this.uuid) {
      //   await this.getDetail();
      if (!this.$store.state.iconstatus) {
        this.readonly = false;
        this.$store.commit("set_iconstatus", false);
      }
    }
  },
  methods: {
    handleEdit() {
      this.readonly = !this.readonly;
      this.$store.commit("set_iconstatus", this.readonly);
    },
    async getDetail() {
      const detail = await getMessageTemplateDetail({
        uuid: this.uuid,
      });
      if (detail.code == 200) {
        this.detail_data = detail.data;
      }
    },
    async func_cancel() {
      if (!this.$store.state.uuid) {
        this.$router.go(-1);
      } else {
        const detail = await getMessageTemplateDetail({
          uuid: this.uuid,
        });
        // if (detail.data.org_level_uuid) {
        //   detail.data.org_level_uuid = detail.data.org_level_uuid.split(',')
        // }
        this.detail_data = detail.data;
      }
    },
    async btn_cancel() {
      if (!this.$store.state.uuid) return;
      const detail = await getMessageTemplateDetail({
        uuid: this.uuid,
      });
      // if (detail.data.org_level_uuid) {
      //   detail.data.org_level_uuid = detail.data.org_level_uuid.split(',')
      // }
      this.btnList = detail.mrbase_sys_function_buttons;
    },
    getBtnClientType(arr) {
      this.client_type = arr;
    },
    tabchange() {
      this.$store.commit("setTab", this.tab);
    },
    handleDel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      }).then((res) => {
        deleteMessageTemplateDetail({ uuids: this.$store.state.uuid }).then(
          (res) => {
            if (res.code == 200) {
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              });
              this.$router.push({
                name: "pushMessageTemplate",
                params: {
                  type: "del",
                },
              });
            }
          }
        );
      });
    },
    async getData(obj) {
      const update = await updateMessageTemplateDetail({
        ...obj,
        // org_level_uuid: this.$store.state.userData.org_level_uuid,
      });
      if (update.code == 200) {
        this.$Message({
          text: this.$t("message_The_operation_was_successful"),
        });

        // 这里的问题  明天记着
        this.disabled = !this.disabled;
        // if (!this.$store.state.iconstatus) {
        //   this.disabled = false
        //   this.$store.commit('set_iconstatus', false)
        // }
        await this.getDetail();
      }
    },
    // 提交按钮
    async success(arr) {},
  },
  computed: {},
  watch: {
    readonly: {
      handler(v) {
        if (!this.$store.state.uuid) return;
        if (!v) {
          this.$route.meta.title = "label_edit_message_template";
          this.$store.commit("set_page_title", "label_edit_message_template");
        } else {
          this.$route.meta.title = "label_view_message_template";
          this.$store.commit("set_page_title", "label_view_message_template");
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.temp_detail /deep/ .v-tab--active {
  color: #000000;
}
.temp_detail /deep/ .v-dialog::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.status {
  color: #fff;
  background-color: #18a874;
  width: 40px;
  height: 25px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  font-size: 12px;
  display: inline-block;
  line-height: 25px;
  text-align: center;
}
.is_used {
  background-color: #dedede;
}
.card_title {
  padding: 8px 0 8px 10px !important;
  display: flex;
  justify-content: space-between;
  font-size: 14px !important;
  color: #fff;
  background-color: #000000;
}
.close_dialog {
  width: 32px;
  text-align: center;
  cursor: pointer;
}
</style>
